import {AbstractControl, FormGroup} from '@angular/forms';

export class FormHelper {

  static errors: { [key: string]: string; } = {
    firstname: 'La valeur du champ Prénom semble incorrecte.',
    lastname: 'La valeur du champ Nom semble incorrecte.',
    code: 'Le code que vous avez entré semble invalide. Il se comporte de 6 chiffres',
    email: 'La valeur du champ Email semble incorrecte.',
    mobilePhone: 'La valeur du champ Téléphone semble incorrecte.',
    message: 'La valeur du champ Message semble incorrecte.',
    oldPassword: 'La valeur du champ Ancien mot de passe semble incorrecte. Le mot de passe doit comporter au moins 5 caractères alpha-numériques.',
    plainPassword: 'La valeur du champ Mot de passe semble incorrecte. Le mot de passe doit comporter au moins 5 caractères alpha-numériques.',
    plainPasswordConfirmation: 'Les mots de passe ne correspondent pas, vérifiez qu\'ils soient bien identiques.',
    companyCode: 'Le code que vous avez entré semble incorrect.',
    reference: 'La référence de commande que vous avez entrée semble incorrecte.',
    serverIP: 'La valeur du champ IP semble incorrecte.'
  };

  public static getFirstInvalidControlError(form: FormGroup): string {
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        return FormHelper.errors.hasOwnProperty(name) ? FormHelper.errors[name] : 'Un champ semble invalide, vérifier le formulaire et ressayez.';
      }
    }
    return null;
  }

  public static checkPasswords(plainPassword: AbstractControl, plainPasswordConfirmation: AbstractControl): any {
    const hasError = plainPasswordConfirmation.value !== plainPassword.value;
    const error = hasError ? {incorrect: true} : null;
    plainPasswordConfirmation.setErrors(error);
    return error;
  }

  public static checkFieldValidity(control: AbstractControl, condition: boolean): any {
    const error = condition === false ? {incorrect: true} : null;
    control.setErrors(error);
    return error;
  }

}
